import React from 'react';
import { siteConfig } from '../config/siteConfig';
import ScrollingTitle from '../components/ScrollingTitle/ScrollingTitle';
import './Page.css';

const Imprint = () => {
  const { imprint } = siteConfig;

  return (
    <div className="imprint-page">
      <ScrollingTitle lines={imprint.title.lines} />

      <div className="imprint-content">
        <div className="imprint-container">

          {/* Company Information Section */}
          <div className="imprint-section">
            <div className="imprint-info-block">
              <h3 className="imprint-company-name">{imprint.legalInformation.company.name}</h3>
              <p className="imprint-text">{imprint.legalInformation.company.address.street}</p>
              <p className="imprint-text">{imprint.legalInformation.company.address.city}</p>
              <p className="imprint-text">{imprint.legalInformation.company.address.country}</p>
            </div>

            <div className="imprint-info-block">
              <p className="imprint-text">
                <a href={imprint.legalInformation.dutyText.url} target="_blank" rel="noopener noreferrer" className="imprint-link">
                  {imprint.legalInformation.dutyText.text}
                </a>
              </p>
            </div>

            <div className="imprint-info-block">
              <h3 className="imprint-subsection-title">{imprint.legalInformation.mediaOwner.title}</h3>
              <p className="imprint-text">{imprint.legalInformation.mediaOwner.name}</p>
              <p className="imprint-text">{imprint.legalInformation.mediaOwner.address}</p>
              <p className="imprint-text">{imprint.legalInformation.mediaOwner.registration.commercialRegister}</p>
              <p className="imprint-text">{imprint.legalInformation.mediaOwner.registration.vatId}</p>
              <p className="imprint-text">
                <a href={imprint.legalInformation.mediaOwner.email.link} className="imprint-link">
                  {imprint.legalInformation.mediaOwner.email.display}
                </a>
              </p>
            </div>

            <div className="imprint-info-block">
              <p className="imprint-text">
                <a href={imprint.legalInformation.mediaOwner.additionalInfo.url} target="_blank" rel="noopener noreferrer" className="imprint-link">
                  {imprint.legalInformation.mediaOwner.additionalInfo.text}
                </a>
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Imprint;